import { __ } from '@wordpress/i18n';
import { Music } from 'lucide-react';
import { createMediaField } from './media-field';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		audio: {
			insertAudio: (attrs?: { url?: string; title?: string }) => ReturnType;
		};
	}
}

export const AudioField = createMediaField({
	name: 'audio',
	dataType: 'audio',
	libraryType: 'audio',
	addLabel: __('Add Audio', 'allcoach'),
	subLabel: __('Click to select from media library', 'allcoach'),
	icon: Music,
	commandName: 'insertAudio',
});
